import { useInfiniteQuery } from '@tanstack/react-query';
import authAxios from '@services/authAxios';

export const useGetInfiniteListMasterProduct = ({ search, enabled }) => {
    return useInfiniteQuery({
        queryKey: ['master-product', { search }],
        queryFn: async ({ pageParam, queryKey }) => {
            const [_key, { search }] = queryKey;
            let searchParams = {};

            if (typeof search === 'string' && search.trim() !== '') {
                searchParams = { search };
            } else if (typeof search === 'object' && search !== null) {
                searchParams = {
                    ...(search.search && { search: search.search }),
                    ...(search.customer_id && { customer_id: search.customer_id }),
                    status: true,
                };
            }

            const { data } = await authAxios.get('/api/v1/master-data/product', {
                params: {
                    page: pageParam,
                    limit: 20,
                    ...searchParams,
                },
            });

            return data;
        },

        select: (data) => {
            return data.pages.flatMap((page) =>
                page.data.page_data.map((item) => ({
                    ...item,
                    id: item.code?.trim() || item.barcode,
                    brand: item.brand.replace(/^brand:/i, '').trim(),
                })),
            );
        },
        initialPageParam: 1,
        getNextPageParam: (lastPage, pages) => {
            if (lastPage?.data?.current_page < lastPage?.data?.total_page) {
                return lastPage?.data?.current_page + 1;
            }
            return undefined;
        },
        enabled:
            enabled && (typeof search === 'string' ? search.length > 3 : !!(search?.search || search?.customer_id)),
        retry: false,
    });
};
